import {
    AutomaticCheckIssueDTO,
    AutomaticCheckIssueType,
} from '../../../../../../../types/automaticCheckJournal';
import { journalTexts } from '../../../../../../../consts/text';

const mapIssueType = (type: AutomaticCheckIssueType) => {
    switch (type) {
        case 'MISSING_ATTENDANCE':
            return journalTexts.journalDetails.common.automaticCheckJournal.details.issue
                .MISSING_ATTENDANCE;
        case 'MISSING_CHILDREN':
            return journalTexts.journalDetails.common.automaticCheckJournal.details.issue
                .MISSING_CHILDREN;
        case 'MISSING_TOPIC':
            return journalTexts.journalDetails.common.automaticCheckJournal.details.issue
                .MISSING_TOPIC;
        case 'MISSING_SCHEDULE_FOR_DATE':
            return journalTexts.journalDetails.common.automaticCheckJournal.details.issue
                .MISSING_SCHEDULE_FOR_DATE;
        case 'MISSING_QUALIFICATION_BASIS':
            return journalTexts.journalDetails.common.automaticCheckJournal.details.issue
                .MISSING_QUALIFICATION_BASIS;
        case 'MISSING_DAILY_SCHEDULE':
            return journalTexts.journalDetails.common.automaticCheckJournal.details.issue
                .MISSING_DAILY_SCHEDULE;
        case 'MISSING_WEEKLY_SCHEDULE':
            return journalTexts.journalDetails.common.automaticCheckJournal.details.issue
                .MISSING_WEEKLY_SCHEDULE;
        default:
            return journalTexts.journalDetails.common.automaticCheckJournal.details.issue
                .UNKNOWN_TOPIC;
    }
};
export const parseIssueHeader = (issue: AutomaticCheckIssueDTO) => {
    return issue.date ? `${issue.date} ${mapIssueType(issue.type)}` : mapIssueType(issue.type);
};
